import React from 'react'
import PropTypes from 'prop-types'

const ProjectsIcon = props => {
  return props.active ? (
    <svg
      aria-hidden="true"
      className="navigation-icon active"
      width="72"
      height="72"
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Projects</title>
      <defs>
        <filter
          x="-61.4%"
          y="-61.4%"
          width="222.7%"
          height="222.7%"
          filterUnits="objectBoundingBox"
          id="projects_filter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="9" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowBlurOuter1" />
        </filter>
        <path
          d="M20.87 38.087a19.94 19.94 0 012.149-7.652h5.503c-.58 2.418-.923 4.992-1.02 7.652H20.87zm7.652 10.522h-5.503a19.95 19.95 0 01-2.15-7.652h6.634c.096 2.66.438 5.233 1.019 7.652zm9.565-18.174v7.652h-7.652c.098-2.675.445-5.25 1.034-7.652h6.618zm0 10.522v7.652h-6.618c-.589-2.403-.936-4.977-1.034-7.652h7.652zm-8.81 10.521A24.591 24.591 0 0030.889 55c.444.787.934 1.533 1.459 2.218a20.17 20.17 0 01-7.652-5.739h4.58zm-4.581-22.956a20.16 20.16 0 017.652-5.74A19.058 19.058 0 0030.888 25a24.5 24.5 0 00-1.611 3.522h-4.581zm13.391 22.956v6.696c-2.215-.707-4.298-3.137-5.74-6.696h5.74zm0-30.608v6.695h-5.74c1.442-3.559 3.525-5.99 5.74-6.695zm3.826 27.739v-7.652h7.652c-.098 2.675-.446 5.249-1.034 7.652h-6.618zm5.74 8.608A19.128 19.128 0 0049.111 55a24.516 24.516 0 001.61-3.52h4.582a20.166 20.166 0 01-7.652 5.738zm-5.74-19.13v-7.652h6.618c.588 2.402.936 4.977 1.034 7.652h-7.652zm5.74-15.304a20.166 20.166 0 017.651 5.739h-4.581A24.5 24.5 0 0049.112 25a19.063 19.063 0 00-1.46-2.217zm-5.74 4.782V20.87c2.215.706 4.298 3.136 5.74 6.695h-5.74zm0 30.609v-6.696h5.74c-1.442 3.56-3.525 5.989-5.74 6.696zM59.13 38.087h-6.633c-.096-2.662-.438-5.235-1.019-7.652h5.503a19.946 19.946 0 012.15 7.652zm0 2.87a19.947 19.947 0 01-2.149 7.652h-5.503c.58-2.419.923-4.992 1.02-7.652h6.632zM40 18c-12.131 0-22 9.869-22 22s9.869 22 22 22 22-9.869 22-22-9.869-22-22-22z"
          id="projects_path"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use fill="#000" filter="url(#projects_filter)" href="#projects_path" />
        <use fill="#FFF" href="#projects_path" />
      </g>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      width="72"
      height="72"
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Projects</title>
      <path
        d="M20.87 38.087a19.94 19.94 0 012.149-7.652h5.503c-.58 2.418-.923 4.992-1.02 7.652H20.87zm7.652 10.522h-5.503a19.95 19.95 0 01-2.15-7.652h6.634c.096 2.66.438 5.233 1.019 7.652zm9.565-18.174v7.652h-7.652c.098-2.675.445-5.25 1.034-7.652h6.618zm0 10.522v7.652h-6.618c-.589-2.403-.936-4.977-1.034-7.652h7.652zm-8.81 10.521A24.591 24.591 0 0030.889 55c.444.787.934 1.533 1.459 2.218a20.17 20.17 0 01-7.652-5.739h4.58zm-4.581-22.956a20.16 20.16 0 017.652-5.74A19.058 19.058 0 0030.888 25a24.5 24.5 0 00-1.611 3.522h-4.581zm13.391 22.956v6.696c-2.215-.707-4.298-3.137-5.74-6.696h5.74zm0-30.608v6.695h-5.74c1.442-3.559 3.525-5.99 5.74-6.695zm3.826 27.739v-7.652h7.652c-.098 2.675-.446 5.249-1.034 7.652h-6.618zm5.74 8.608A19.128 19.128 0 0049.111 55a24.516 24.516 0 001.61-3.52h4.582a20.166 20.166 0 01-7.652 5.738zm-5.74-19.13v-7.652h6.618c.588 2.402.936 4.977 1.034 7.652h-7.652zm5.74-15.304a20.166 20.166 0 017.651 5.739h-4.581A24.5 24.5 0 0049.112 25a19.063 19.063 0 00-1.46-2.217zm-5.74 4.782V20.87c2.215.706 4.298 3.136 5.74 6.695h-5.74zm0 30.609v-6.696h5.74c-1.442 3.56-3.525 5.989-5.74 6.696zM59.13 38.087h-6.633c-.096-2.662-.438-5.235-1.019-7.652h5.503a19.946 19.946 0 012.15 7.652zm0 2.87a19.947 19.947 0 01-2.149 7.652h-5.503c.58-2.419.923-4.992 1.02-7.652h6.632zM40 18c-12.131 0-22 9.869-22 22s9.869 22 22 22 22-9.869 22-22-9.869-22-22-22z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  )
}

Window.propTypes = {
  active: PropTypes.string
}

export default ProjectsIcon
